import _ from "lodash";

function countFilter(data, count) {
    return _.filter(data, (item) => {
        let condi = false;
        let countSplit = item['before_decided_ball_count'].split('-');
        
        let strike = countSplit[0]*1;
        let ball = countSplit[1]*1;
        let ballCount = item['before_decided_ball_count'];

        if(count === 'first' && (ballCount === '0-0')) {
            condi = true;
        } else if(count === '2strike' && (strike === 2)) {
            condi = true;
        } else if(count === 'batter' && 
                ( ballCount === '0-3' || ballCount === '1-3' || ballCount === '0-2'
                || ballCount === '1-2' || ballCount === '0-1')
            ) {
            condi = true;
        } else if(count === 'pitcher' && 
                ( ballCount === '1-0' || ballCount === '2-0' || ballCount === '2-1'
                || ballCount === '2-2')
            ) {
            condi = true;
        } else if(count === 'full' && (ballCount === '2-3')) {
            condi = true;
        }

        return condi;
    });
}

function playerTypeFilter(data, value, playerType) {
    let returnData = null;
    if(playerType === 'batter') {
        returnData = pitcherTypeFilter(data, value);
    } else {
        returnData = batterTypeFilter(data, value);
    }

    return returnData
}

function batterTypeFilter(data, batterType) {
    return _.filter(data, (item) => {
        let condi = false;

        if(item['batting_hand'] === batterType) {
            condi = true;
        }

        return condi;
    });
}

function pitcherTypeFilter(data, pitcherType) {
    return _.filter(data, (item) => {
        let condi = false;

        if(item['pitching_form'] === "801" && (item['pitching_hand'] === pitcherType)) {
            condi = true;
        } else if(item['pitching_form'] !== "801" && (pitcherType ==='S')) { 
            condi = true;
        }

        return condi;
    })
}

export {countFilter, playerTypeFilter};